/**
 * ZenMarkup Privacy Analytics — CSV Export API module.
 *
 * Handles CSV export download via the /export REST endpoint.
 * Extracted from api.js to keep modules under 200 lines.
 */

import * as state from './state.js';

/**
 * Download CSV export for a dashboard tab.
 *
 * Fetches the /export endpoint as a blob and triggers a browser
 * download via a temporary object URL.
 *
 * @param {string} tab  Tab name: overview, traffic, geography, behavior.
 * @return {Promise<void>}
 */
export async function fetchExport(tab) {
	const range = state.getRange();
	let qs = 'export?tab=' + encodeURIComponent(tab)
		+ '&period=' + encodeURIComponent(range);

	if (range === 'custom') {
		qs += '&from=' + encodeURIComponent(state.getStartDate())
			+ '&to=' + encodeURIComponent(state.getEndDate());
	}

	try {
		const response = await fetch(window.zmpaDashData.restUrl + qs, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'X-WP-Nonce': window.zmpaDashData.nonce
			}
		});

		if (!response.ok) {
			throw new Error('HTTP ' + response.status);
		}

		const blob = await response.blob();
		const disposition = response.headers.get('Content-Disposition') || '';
		const match = disposition.match(/filename="?([^"]+)"?/);
		const filename = match ? match[1] : 'analytics-' + tab + '.csv';

		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	} catch (err) {
		console.error('[ZenMarkup Privacy Analytics] Failed to export CSV:', err);
	}
}
